import './style.css';
import { Link } from "react-router";

const Sidebar = () => {

  return (
    <div className="container-fluid">
        <div className="row flex-nowrap">
            <div className="col-auto col-md-8 col-xl-12 px-sm-2 px-0 bg-success">
                <nav className="d-flex flex-column align-items-center align-items-sm-start px-2 pt-2 text-white min-vh-100">
                    <ul className="nav flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start link-light gap-2" id="menu">
                        <li className="w-100 mnopc rounded">
                            <Link to={"/home"} className="nav-link align-middle px-2 link-light focus-ring focus-ring-light rounded d-flex align-items-center gap-2" >
                                <i className="fs-4 bi-house"></i> <span className="ms-1 d-none d-sm-inline">Inicio</span>
                            </Link>                          
                        </li>
                        <li className="w-100 mnopc rounded">
                            <Link to="/updateUsuario" className="nav-link px-2 align-middle link-light focus-ring focus-ring-light rounded d-flex  align-items-center gap-2">
                                <i className="fs-4 bi bi-file-earmark-person-fill"></i> <span className="ms-1 d-none d-sm-inline">Actualizar empleador</span>
                            </Link>                                
                        </li>
                        <li className="w-100 mnopc rounded">
                            <Link to="/updateCasos" className="nav-link px-2 align-middle link-light focus-ring focus-ring-light rounded d-flex  align-items-center gap-2">
                                <i className="fs-4 bi bi-grid-3x3-gap"></i> <span className="ms-1 d-none d-sm-inline">Cambiar estado afiliación</span> 
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
  );
};

export default Sidebar;
